import React from 'react';

import InfiniteList from "../InfiniteList";

class NoteList extends React.Component {

    constructor(...args) {
        super(...args);
        this.state = {
            modalVisible: false,
            loading: false,
            systemConfig: {},
            visiting: {},
            loginBuddy: "",
            collapsed: true
        };
    }


    loadAuth(buddyName) {
        let formData = new FormData()
        formData.append('buddyName', buddyName)

        let host = process.env.REACT_APP_HOST

        this.setState({loading: true})

        fetch(host + "/site/buddy/api/auth", {method: 'POST', body: formData, credentials: 'include',
            xhrFields: {
                withCredentials: true
            }})
            .then(response => response.json())
            .then(data => {
                if(this.unmount) return;

                if(data.success) {

                    if(data.data.map.loginBuddy) {
                        this.setState({
                            auth: data,
                            visiting: data,
                            loginBuddy: data.data.map.loginBuddy.buddyName,
                        })

                        var infiniteList = <InfiniteList buddyName={this.state.loginBuddy} type={this.state.type}/>

                        this.setState({
                            infiniteList: infiniteList,
                        })

                        this.setState({
                            loading: false,
                        })

                    } else {
                        window.location.href="/site/buddy/login"
                    }

                }

            })

    }

    componentDidMount() {
        console.log("mount")

        this.setState({
            loginBuddy: this.props.buddyName,
            type: this.props.type,
        })
        var buddyName = this.props.buddyName
        this.loadAuth(buddyName)

    }

    render() {

        return (
            <>{this.state.infiniteList}</>
        );

    }

}

export default NoteList;